import { render, staticRenderFns } from "./LanguageSelection.vue?vue&type=template&id=54cd6ec6&scoped=true&"
import script from "./LanguageSelection.vue?vue&type=script&lang=js&"
export * from "./LanguageSelection.vue?vue&type=script&lang=js&"
import style0 from "./LanguageSelection.vue?vue&type=style&index=0&id=54cd6ec6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cd6ec6",
  null
  
)

export default component.exports